// สิทธิ์ตามบทบาท — ตรวจที่ service layer ของ server ทุกเส้นทาง (REST / MCP / บอท ใช้ชุดเดียวกัน)
// บทเรียนระบบเดิม: มี 29 เส้นทางเขียนข้อมูลที่ลืมตรวจสิทธิ์ — ที่นี่ทุก action ต้องมีชื่อในตารางนี้ ไม่มีชื่อ = ห้าม
export const ROLES = ['admin', 'office', 'technician', 'accounting', 'viewer', 'service'];
export const ROLE_INFO = {
    admin: { label: 'ผู้ดูแลระบบ' },
    office: { label: 'ออฟฟิศ / แอดมิน' },
    technician: { label: 'ช่าง' },
    accounting: { label: 'บัญชี' },
    viewer: { label: 'ดูอย่างเดียว' },
    service: { label: 'ระบบอัตโนมัติ' },
};
export const ACTIONS = [
    'job.read',
    'job.create',
    'job.update',
    'job.assign',
    'job.stage',
    'job.cancel',
    'job.close', // ปิดงานจาก "รอแอดมิน" (ช่าง/บอทปิดเองไม่ได้)
    'job.nocharge.approve', // ยืนยัน "ไม่คิดเงิน" (ประกัน/สัญญา/งานภายใน) — ตัดซ้อนด้วย Setting adminReview.noChargeApproverRoles
    'job.admin_queue.read', // อ่านคิวรอแอดมิน (+ CSV)
    'job.reopen',
    'job.lines',
    'job.billing',
    'job.secret.read', // ดูรหัสผ่านเครื่องลูกค้า
    'visit.manage',
    'visit.update_own', // ช่างอัปเดตรอบของตัวเอง (กำลังไป/ถึงแล้ว/เสร็จ)
    'attachment.upload',
    'checklist.fill',
    'checklist.exception.approve', // อนุมัติข้อยกเว้นในเช็กลิสต์ (เช่น wiremap ไม่ผ่าน) — ตัดซ้อนด้วย adminReview.noChargeApproverRoles เหมือนยืนยันไม่คิดเงิน
    'signature.capture',
    'quotation.manage',
    'customer.read',
    'customer.write',
    'asset.read',
    'asset.write',
    'contract.read',
    'contract.write',
    'rma.manage',
    'report.read',
    'report.money',
    'settings.manage',
    'user.manage',
    'apikey.manage',
    'security.manage', // ดูประวัติเข้าสู่ระบบ / ปลดล็อกผู้ใช้-IP (admin เท่านั้น)
    'draft.create', // บอทลูกค้าสร้างร่างงาน
    'ledger.read', // สมุดเงินเข้า/เงินออก
    'ledger.write',
    'ev.report.read', // ดูรายงานติดตั้ง EV (ส่งค่ายรถ) + ดาวน์โหลดเล่ม
    'ev.report.manage', // แก้ข้อมูลเล่ม, สแกนใบเซ็น, ปิด/เปิดรายงาน, ระบุช่องรูปยืนยันเดิม
    'ev.photo.upload', // อัปรูปหน้างาน EV + กดส่งงาน (รูปครบ)
    // เรื่องรอคุณฟลุ๊คตัดสินใจ (docs/DECISIONS.md) — ผู้ใช้: เฉพาะเจ้าของ (DECISIONS_OWNER_USER_IDS) ไม่ผูกกับบทบาท · API key: scope decisions
    'decision.read',
    'decision.propose', // เสนอเรื่องใหม่ (API key เท่านั้น)
    'decision.decide', // อนุมัติ/ไม่อนุมัติ/ขอแก้ไข (เจ้าของเท่านั้น — API อนุมัติไม่ได้)
    'techgroup.read', // ดูคิว "รอแอดมินจับคู่" ข้อความ/รูปจากกลุ่ม LINE ช่างเทคนิค
    'techgroup.manage', // จับคู่/ย้าย/นำออก ข้อความจากกลุ่มช่าง + ส่งสรุปลงกลุ่มหลักผ่านบอท
    // การ์ดงาน LINE Flex (FLEX_JOBCARD_ENABLED — docs/FLEX_JOBCARD.md)
    'job.accept', // ช่างกด "รับงาน" / "นัดเวลา" บนการ์ดงานในกลุ่ม LINE (เพิ่มตัวเองเป็นผู้รับผิดชอบ + นัดรอบของตัวเอง)
    'job.timeline.read', // ไทม์ไลน์ เปิดงาน → รับงาน → ออกเดินทาง → ถึงหน้างาน → ปิดงาน
    'line.card.send', // สร้าง/ส่งการ์ดงานเข้ากลุ่มหลักผ่าน API (แอดมินผู้ช่วย)
];
/** ไม่มีบทบาทผู้ใช้ใดได้ (admin ก็ไม่ได้) — ผู้ใช้ตรวจด้วยรายชื่อเจ้าของ (server/services/decisions.ts) · API key ตรวจด้วย scope */
export const DECISION_ACTIONS = ['decision.read', 'decision.propose', 'decision.decide'];
const ALL = new Set(ACTIONS.filter((a) => !DECISION_ACTIONS.includes(a)));
const READ = ['job.read', 'customer.read', 'asset.read', 'contract.read', 'report.read', 'job.admin_queue.read', 'ev.report.read', 'job.timeline.read'];
const MATRIX = {
    admin: ALL,
    office: new Set([
        ...READ,
        'job.create', 'job.update', 'job.assign', 'job.stage', 'job.cancel', 'job.reopen', 'job.lines', 'job.billing',
        'job.close', 'job.nocharge.approve', 'job.secret.read', 'visit.manage', 'visit.update_own', 'attachment.upload', 'checklist.fill', 'checklist.exception.approve', 'signature.capture',
        'quotation.manage', 'customer.write', 'asset.write', 'contract.write', 'rma.manage', 'report.money', 'draft.create',
        'ledger.read', 'ev.report.manage', 'ev.photo.upload', 'techgroup.read', 'techgroup.manage', 'job.accept', 'line.card.send',
    ]),
    technician: new Set([
        ...READ,
        'job.create', 'job.update', 'job.stage', 'job.lines', 'job.secret.read',
        'visit.update_own', 'attachment.upload', 'checklist.fill', 'signature.capture', 'asset.write', 'rma.manage',
        'ev.photo.upload', 'job.accept',
    ]),
    accounting: new Set([...READ, 'job.billing', 'job.close', 'job.nocharge.approve', 'quotation.manage', 'customer.write', 'report.money', 'ledger.read', 'ledger.write']),
    viewer: new Set(READ),
    // service key: สิทธิ์จริงถูกตัดด้วย scope ของ key อีกชั้น (ดู apps/server/src/auth)
    service: new Set([
        ...READ, 'job.create', 'job.update', 'job.assign', 'job.stage', 'job.lines', 'visit.manage', 'quotation.manage',
        'customer.write', 'draft.create', 'attachment.upload', 'ledger.read', 'ledger.write', 'ev.photo.upload',
        'decision.read', 'decision.propose', 'line.card.send',
    ]),
};
export function can(role, action) {
    return MATRIX[role]?.has(action) ?? false;
}
export function isRole(v) {
    return typeof v === 'string' && ROLES.includes(v);
}
/** scope ของ API key → ชุด action (ตัดซ้อนกับ role service) */
export const API_SCOPES = {
    read: READ,
    jobs: ['job.create', 'job.update', 'job.assign', 'job.stage', 'job.lines', 'visit.manage', 'attachment.upload', 'ev.photo.upload', 'job.timeline.read'],
    quotations: ['quotation.manage'],
    customers: ['customer.write'],
    drafts: ['draft.create'],
    /** บอทแอดมินอ่านคิว "รอแอดมิน" (อ่านอย่างเดียว) */
    admin_queue: ['job.read', 'job.admin_queue.read'],
    /** ผู้ช่วยบัญชี (ledger API — /api/ledger/v1) */
    ledger: ['ledger.read', 'ledger.write'],
    /** ระบบที่เสนอเรื่องให้เจ้าของตัดสินใจ — สร้าง/อ่านได้ อนุมัติไม่ได้ · ไม่ได้สิทธิ์อื่นใดเลย */
    decisions: ['decision.read', 'decision.propose'],
    /** แอดมินผู้ช่วย (operator): สร้าง/ส่งการ์ดงาน LINE Flex + อ่านไทม์ไลน์ (docs/FLEX_JOBCARD.md) — ไม่ได้สิทธิ์แก้งาน */
    line_cards: ['line.card.send', 'job.timeline.read'],
};
export function canWithScopes(scopes, action) {
    if (!can('service', action))
        return false;
    return scopes.some((s) => API_SCOPES[s]?.includes(action));
}
/** บทบาทที่ตั้งเป็นผู้ยืนยัน "ไม่คิดเงิน" ได้ (ตั้งค่า adminReview.noChargeApproverRoles เลือกได้จากชุดนี้เท่านั้น) */
export const NO_CHARGE_APPROVER_ROLES = ['admin', 'office', 'accounting'];
/** ยืนยันไม่คิดเงินได้ไหม: ต้องมีสิทธิ์ job.nocharge.approve และบทบาทอยู่ในรายชื่อที่ตั้งไว้ (ค่าเริ่มต้น admin เท่านั้น) */
export function canApproveNoCharge(role, approverRoles) {
    return can(role, 'job.nocharge.approve') && approverRoles.includes(role);
}
/**
 * อนุมัติข้อยกเว้นในเช็กลิสต์ (wiremap ไม่ผ่าน) ได้ไหม — ใช้รายชื่อบทบาทชุดเดียวกับยืนยัน "ไม่คิดเงิน" (ค่าเริ่มต้น admin เท่านั้น)
 * แต่ต้องมีสิทธิ์ checklist.exception.approve ด้วย (admin/office เท่านั้น — บัญชี/ช่าง/บอทไม่ได้แม้อยู่ในรายชื่อ)
 */
export function canApproveChecklistException(role, approverRoles) {
    return can(role, 'checklist.exception.approve') && approverRoles.includes(role);
}
//# sourceMappingURL=permissions.js.map